import React from 'react'
import { aiLabelBox } from 'utils/aiLabelHelpers'
import type { AiLabelState } from 'EditorApp/types'

interface AiLabelProps {
  readonly aiLabel: AiLabelState
  readonly pageWidth: number
  readonly pageHeight: number
}

// The mandatory EU AI Act marking. Rendered by `Page`, so it covers the editor
// canvas and the read-only doc previews alike. Exports draw their own copy of
// the same box from the server side.
const AiLabel = ({ aiLabel, pageWidth, pageHeight }: AiLabelProps) => {
  const box = aiLabelBox(aiLabel, pageWidth, pageHeight)

  return (
    <img
      className="AiLabel"
      src={`/images/ai-label-${aiLabel.variant}.svg`}
      alt="Contains AI generated content"
      style={box}
    />
  )
}

export default AiLabel
